import { Role } from '@infiltre/shared';

/**
 * Single home for role → CSS color-token resolution. Used by FinishedScreen,
 * WordReveal, VerdictScreen, and any future role-tinted surface.
 * Returns a CSS `var(...)` reference so callers compose directly into
 * `style.color`, `style.background`, etc.
 */
export const roleTint = (role: Role | null | undefined): string => {
  if (role === Role.Flic) return 'var(--color-civ)';
  if (role === Role.Infiltre) return 'var(--color-und)';
  if (role === Role.Clochard) return 'var(--color-white-gold)';
  return 'var(--color-ink)';
};

/** Black on Clochard's gold; white on Flic blue / Infiltré red. */
export const roleTintTextColor = (role: Role | null | undefined): string =>
  role === Role.Clochard ? 'var(--color-ink)' : 'white';
